import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export interface ConfirmationDialogData {
  message: string,
  yes?: string,
  no?: string,
  title?: string,
  challengeString?: string
};

@Component({
  selector: 'app-confirmation-dialog',
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  @ViewChild(MatInput) challenge!: MatInput;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    if (data.yes === undefined) {
      data.yes = "Yes";
    }
    if (data.no === undefined) {
      data.no = "No";
    }
    if (data.title === undefined) {
      data.title = "Confirm";
    }
  }

  ngAfterViewInit() {
    /// this avoids an ExpressionChangedAfterItHasBeenCheckedError error
    this.cdr.detectChanges();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  get yesDisabled(): boolean {
    if (this.challenge === undefined) {
      return false;
    }
    if (this.data.challengeString === undefined) {
      return false;
    }
    if (this.challenge.value !== this.data.challengeString) {
      return true;
    }
    return false;
  }

}